import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-themify-icons-page-configurator',
	templateUrl:'./ThemifyIconsPageConfiguratorPluginCompPage.html',
	styles: [],
	styleUrls:['./ThemifyIconsPageConfiguratorPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class ThemifyIconsPageConfiguratorPluginCompPage
{
	mdContent_1111 = `\`\`\`java
import com.jwebmp.plugins.themify.icons.ThemifyIconsPageConfigurator;
\`\`\``;
	mdContent_1112 = `\`\`\`java
module com.myapp {
    requires com.jwebmp.plugins.themify.icons;
}
\`\`\``;
}
